import React, { useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Avatar,
  Button,
  Container,
  Paper,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextareaAutosize,
  Stack,
  Divider,
  Grid,
  Autocomplete,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  InputAdornment,
  capitalize,
  Fab,
  Chip,
  Tabs,
  Tab,
  ToggleButtonGroup,
  ToggleButton,
  Card,
  CardContent,
  IconButton,
  Menu,
} from '@mui/material';
import AppTheme from '../../../shared-theme/AppTheme';
import { CssBaseline } from '@mui/material';
import SideMenu from '../../../components/SideMenu';
import Header from '../../../components/Header';
import Can from '../../../components/Can';
import { Add, ArrowBack, CalculateOutlined, Check, Close, RemoveCircle, SetMealSharp, MoreVert, Print, RemoveCircleOutline, FmdBad, FmdBadOutlined, WalletOutlined, Description, Edit, ListAltOutlined, HistoryOutlined, ReceiptLongOutlined, HandshakeOutlined, RequestQuoteOutlined, VerifiedUserOutlined } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import Selector from '../../../components/Selector';
import { DatePicker } from '@mui/x-date-pickers';
import { StyledCellHeader } from '../../../components/StyledCellHeader';
import CrearBancoDialog from '../../configuracion/bancos/crearbancodialog';
import CrearMonedaDialog from '../../configuracion/monedas/crearmonedadialog';
import AutocompleteWithAdd from '../../../components/AutocompleteWithAdd';
import { fetchBancos, fetchMonedas, fetchProductosFinancieros, fetchProveedores } from '../../../utils/generalsFetch';
import { formatIdentification, formatNumber, formatNumberWithCommas, formatPhone } from '../../../utils/generalFunctions';
import { gray } from '../../../shared-theme/themePrimitives';
import CobrarInicialDialog from './iniciales/cobrarinicialdialog';
import { calculoabsoluto } from './funciones/funciones';
import AlertMessageDialog from '../../../components/Dialogs/alertMessageDialog';
import OnGeneralMessageDialog from '../../../components/Dialogs/OnGeneralMessageDialog';
import TimeLineNotes from './notas/timelinenotes';
import AssignLoanToPortfolioDialog from '../portafolio/assignloantoportofoliodialog';
import EliminarPrestamoPortafolioDialog from '../portafolio/eliminarloantoportofoliodialog';
import HistorialPagosPrestamo from './pagos';
import PromesasTab from './promesas_pago/promesastab';
import CargosAsignadosTab from './cargos_asignados/CargosAsignadosTab';
import GarantiasPrestamo from './garantias/GarantiasPrestamo';
import ContractGenerationDialog from './options/contractgenerationdialog';
import PrintAmortizationDialog from './options/printamortizationdialog';
import EditAmortizationDialog from './options/editamortizationdialog';
import { differenceInDays, isValid, parse, parseISO, differenceInMonths, differenceInWeeks, addMonths, format, addDays } from 'date-fns';
import { a } from '@react-spring/web';


const safeCapitalize = (value) => capitalize(String(value ?? ''));

function DetailField({ label, value, emphasize = false }) {
  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{
          display: 'block',
          fontSize: '0.68rem',
          fontWeight: 600,
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
          mb: 0.5,
        }}
      >
        {label}
      </Typography>
      <Typography
        variant="body2"
        color={emphasize ? 'primary.main' : 'text.primary'}
        sx={{
          fontWeight: emphasize ? 700 : 600,
          fontSize: '0.92rem',
          lineHeight: 1.35,
          wordBreak: 'break-word',
        }}
      >
        {value === null || value === undefined || value === '' ? '—' : value}
      </Typography>
    </Box>
  );
}

function SectionHeader({ title, action }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 2.5,
        pb: 1.25,
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
        <Box sx={{ width: 3, height: 16, borderRadius: 1, bgcolor: 'primary.main' }} />
        <Typography variant="subtitle2" fontWeight={700} sx={{ fontSize: '0.85rem', letterSpacing: '0.01em' }}>
          {title}
        </Typography>
      </Box>
      {action}
    </Box>
  );
}

function EstadoChip({ estado }) {
  let color = 'default';
  if (estado === 'pagado') color = 'success';
  else if (estado === 'pendiente') color = 'warning';
  else if (estado === 'cancelado') color = 'error';
  else if (estado === 'irrecuperable') color = 'warning';
  else if (estado === 'activo') color = 'success';
  else if (estado === 'cancelado') color = 'error';
  return <Chip label={safeCapitalize(estado)} color={color} textTransform="none" size='large'/>;
}


export default function DetallePrestamo() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [openCobrarInicial, setOpenCobrarInicial] = React.useState(false);
  const [montoInicial, setMontoInicial] = React.useState(0);
  const [montoInicialText, setMontoInicialText] = React.useState("0");
  const [moneda, setMoneda] = React.useState(null);
  const [valorCuota, setValorcuotas] = React.useState(0);
  const [deudaTotal, setDeudaTotal] = React.useState(0);
  const [recuperaciones, setRecuperaciones] = React.useState([]);
  const [atraso, setAtraso] = React.useState(0);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [openGeneralAcceptMessageDialog, setOpenGeneralAcceptMessageDialog] = React.useState(false);
  const [openGeneralRejectMessageDialog, setOpenGeneralRejectMessageDialog] = React.useState(false);
  const [openCancelConfirmDialog, setOpenCancelConfirmDialog] = React.useState(false);
  const [openContractDialog, setOpenContractDialog] = React.useState(false);
  const [openPrintAmortizationDialog, setOpenPrintAmortizationDialog] = React.useState(false);
  const [openEditAmortizationDialog, setOpenEditAmortizationDialog] = React.useState(false);
  const [amortizacion, setAmortizacion] = React.useState([]);
  const [prestamo, setPrestamo] = React.useState({});
  const [tabValue, setTabValue] = React.useState("Amortizacion");
  const [messageAlert, setMessageAlert] = React.useState("");
  const [messageIrrecuperable, setMessageIrrecuperable] = React.useState("");

  const [financialProductSelected, setFinancialProductSelected] = React.useState(null);
  const [formulario, setFormulario] = React.useState({})
  const [general, setGeneral] = React.useState({})

  const [mora, setMora] = React.useState({"tipoMora": "fija", "valorMora": "5", "esPorcentaje": true})
  const [interes, setInteres] = React.useState({"tipoInteres": "fijo", "valorInteres": "5"});

  const [productoSelected, setProductoSelected] = React.useState(null);
  const [productos, setProductos] = React.useState([])
  const [camposInventario, setCamposInventario] = React.useState([{}])

  const [formValues, setFormValues] = React.useState({})
  const [errors, setErrors] = React.useState({});
  const [isEditing, setIsEditing] = React.useState(false);
  const [editValues, setEditValues] = React.useState({});
  const [editErrors, setEditErrors] = React.useState({});
  const [savingEdit, setSavingEdit] = React.useState(false);
  const [productosFinancieros, setProductosFinancieros] = React.useState([]);
  const [menuEl, setMenuEl] = React.useState(null);
  const [openAssignPortfolioDialog, setOpenAssignPortfolioDialog] = React.useState(false);
  const [openIrrecuperableDialog, setOpenIrrecuperableDialog] = React.useState(false);
  const [openEliminarPrestamoPortafolioDialog, setOpenEliminarPrestamoPortafolioDialog] = React.useState(false);
  useEffect(() => {
    fetchMonedas({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      const monedaEncontrada = Array.isArray(data) ? data.find((moneda) => moneda.value == "1") : null;
      setMoneda(monedaEncontrada || { label: "RD", value: "1" });
    });
    fetchProductosFinancieros({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setProductosFinancieros(data);
      fetchSolicitud(data);
    });


  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };


  useEffect(() => {
    var data = calculoabsoluto(formValues[10],formValues[11],formValues[13],formValues[12]);
    setDeudaTotal(data["deuda"]);
    setValorcuotas(data["cuotas"]);
  },[formValues])

  const handleInputChange = async (id, value) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [id]: value,
    }));

    if(value != "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [id]: undefined, 
      }));
    }
    else{
      if( formulario.campos.find(campo => campo.id == id)?.required) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [id]: `${formulario.campos.find(campo => campo.id == id).name} es requerido`, 
        }));
      }
    }
    
    // Update backend when campo.id = 14 (mora) is modified
    if (id == 14) {
      try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/prestamos/${prestamo.id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
          },
          body: JSON.stringify({
            mora: value
          })
        });

        if (!response.ok) {
          const error = await response.json();
          console.error('Error updating mora:', error);
          setMessageAlert("Error al actualizar la mora del préstamo.");
          setOpenAlert(true);
          return;
        }

        setMessageAlert("Mora actualizada exitosamente.");
        setOpenAlert(true);
        
        // Refresh loan data to reflect changes
        if (productosFinancieros.length > 0) {
          fetchSolicitud(productosFinancieros);
        }
      } catch (error) {
        console.error('Error updating mora:', error);
        setMessageAlert("Ocurrió un error al actualizar la mora.");
        setOpenAlert(true);
      }
      return;
    }
    
    var calculo = 0
    var error = undefined
    switch (id) {
      case "precio_venta": 
        calculo = parseFloat(value) - parseFloat(montoInicial);
        var error = undefined
        break;
      case "inicial":
        calculo = parseFloat(formValues["precio_venta"]) - parseFloat(value);
        break;
      default:
        return;
    }
    if (calculo < general.montoMinimo ||calculo > general.montoMaximo) {
      error = `Monto debe ser entre ${moneda?.label+"$"+formatNumberWithCommas(general.montoMinimo.toFixed(2))} - ${moneda?.label+"$"+formatNumberWithCommas(general.montoMaximo.toFixed(2))}`
    }
    setFormValues((prevValues) => ({
      ...prevValues,
      [10]: calculo,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [10]: error,
    }));




  };


  /** interesOverride: configuración JSON del producto financiero (ej. interesDiario). fetchPrestamo corre antes de setInteres en el ciclo inicial. */
  const fetchPrestamo = async (prestamo_id, interesOverride = null) => {
    var url = `${process.env.REACT_APP_SERVER_URL}/api/prestamos/detalles/${prestamo_id}`;
    var response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
      }
    });
    if (!response.ok) {
      const error = await response.json();
      console.log(error)
      return;
    }
    var data = await response.json();
    if(data["prestamo"]["metodo"] == "plazo_indefinido") {
      setTabValue("Cuotas");
      url = `${process.env.REACT_APP_SERVER_URL}/api/prestamos/detalles/plazo_indefinido/${prestamo_id}`;
      response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        }
      });
      if (!response.ok) {
        const error = await response.json();
        console.log(error)
        return;
      }
      data = await response.json();

      var fechainicio = data["prestamo"]["fecha_inicio"];
      var interes2 = 0

      const interesParaCalculo = interesOverride ?? interes;

      if (interesParaCalculo?.interesDiario) {
        var cuotas = []
        var cuotasFechas = []
        var ultPago = data.amortizaciones.length>0?data.amortizaciones[data.amortizaciones.length - 1]:null;
        var nocuota = ultPago?ultPago.numero_cuota:0;
        var capital = ultPago?ultPago.capital:data.prestamo.monto_solicitado;

        var fechahoy = new Date();
        var fechainicio = new Date(data.prestamo.fecha_inicio);
        var fechaultimacuota = new Date(data.prestamo.fecha_ultima_cuota);
    //    var meses = Math.floor((fechahoy - (data.prestamo.fecha_ultimo_pago_original?fechaultimopago:fechainicio)) / (1000 * 60 * 60 * 24 * 30));
    

        var dias = Math.floor((fechahoy - (data.prestamo.fecha_ultima_cuota?fechaultimacuota:fechainicio)) / (1000 * 60 * 60 * 24));
        var quincenas = Math.floor(dias / 15);
        var semanas = Math.floor(dias / 7);
        var meses = Math.floor(dias / 30);
        var tiempo = 0;
    
        if(data.prestamo.frecuencia == "Diario") {
          tiempo = dias;
        }else if(data.prestamo.frecuencia == "Semanal") {
          tiempo = semanas;
        }else if(data.prestamo.frecuencia == "Quincenal") {
          tiempo = quincenas;
        }
        else if(data.prestamo.frecuencia == "Mensual") {
          tiempo = 1;
        }
        
        data.amortizaciones_pendientes.forEach(amortizacion => {
          var fecha = new Date(amortizacion.fecha_cuota);
    
          const day = String(fecha.getUTCDate()).padStart(2, "0");
          const month = String(fecha.getUTCMonth() + 1).padStart(2, "0");
          const year = fecha.getUTCFullYear();
    
        
          cuotasFechas.push({fecha:`${day}-${month}-${year}`,nocuota:amortizacion.nocuota});
          });
    
    
          for(var i = 0; i < tiempo; i++) {
            var fecha = data.prestamo.fecha_ultima_cuota?fechaultimacuota:fechainicio;      
    
            if(data.prestamo.frecuencia == "Diario") { 
              fecha = addDays(fecha, (i+1));
              fecha = fecha.getDate() + "-" + ((fecha.getMonth()+1) ) + "-" + fecha.getFullYear();        
            }else if(data.prestamo.frecuencia == "Semanal") {
              fecha = addDays(fecha, (i+1)*7); 
              fecha = fecha.getDate() + "-" + ((fecha.getMonth()+1) ) + "-" + fecha.getFullYear();
            }else if(data.prestamo.frecuencia == "Quincenal") {
              fecha = addDays(fecha, i*15); 
              fecha = fecha.getDate() + "-" + ((fecha.getMonth()+1) ) + "-" + fecha.getFullYear();
            }else if(data.prestamo.frecuencia == "Mensual") {
              fecha = addMonths(fecha, (i+1));        
              fecha = fecha.getDate() + "-" + ((fecha.getMonth()+1) ) + "-" + fecha.getFullYear();
            }
            var existe = cuotasFechas.find(cuota => cuota.fecha == fecha);
    
//            if(!existe) {
  //            cuotasFechas.push({fecha:fecha,nocuota:null})
    //        }     
          }
          

          for(var i = 0; i < cuotasFechas.length; i++) {
            var fecha = cuotasFechas[i].fecha;
    
            if(cuotasFechas[i].nocuota == null) {
              nocuota++;
              // Get the month gap between now and the cuota's date
              // fecha is in format "dd/mm/yyyy"
              const cuotaDate =  parse(fecha, 'dd-MM-yyyy', new Date());
              const now = new Date();
              var dias = differenceInDays(now, cuotaDate);        
              var moraCalculada = 0;
              if(dias >= 30) {
                moraCalculada = (capital * (data.prestamo.interes/100))*(3/100)
                setAtraso((atraso+(capital * (data.prestamo.interes/100))+moraCalculada).toFixed(2));
              }

    
              cuotas.push({
                nocuota: nocuota,
                Fecha:  fecha,
                capital: data.prestamo.capitalPendiente,
                interes: data.prestamo.interes,
                mora: formatNumberWithCommas(moraCalculada.toFixed(2)),
                valor:(capital * (data.prestamo.interes/100)).toFixed(2),
                descuento:0,
                pagadodescuento:0,
                status:'noexiste'
              });
            }else{
//              setAtraso(data.atraso);
              
              var amortizacion = data.amortizaciones_pendientes.find(amortizacion => amortizacion.nocuota == cuotasFechas[i].nocuota);
              var nocuota = cuotasFechas[i].nocuota;
    
              cuotas.push({
                nocuota: nocuota,
                numero_cuota: nocuota,
                Fecha:  fecha,
                fecha_pagado: amortizacion.fecha_pagado,
                interes_acumulado: parseFloat(amortizacion.interes_acumulado),
                capital: data.prestamo.capitalPendiente,
                capitalPendiente: amortizacion.capitalPendiente,
                interes: amortizacion.interes,
                interesPagado: amortizacion.interesPagado,
                capitalPagado: amortizacion.capitalPagado,
                aumento_interes: amortizacion.aumento_interes,
                mora: amortizacion.mora,
                valor:amortizacion.valor,
                cuotaoriginal:amortizacion.cuota,
                descuento:amortizacion.descuento,
                pagadodescuento:0,
                status:'existe'
              });
            }
          }
        
        
          cuotas.map((cuota,index) => {
            const dateString = fechainicio;
            const date = new Date(dateString);
    
            // Get UTC components
            const day = String(date.getUTCDate()).padStart(2, '0');
            const month = String(date.getUTCMonth() + 1).padStart(2, '0');
            const year = date.getUTCFullYear();
            const formatted = `${day}-${month}-${year}`;
            var previousAmortizacion = null;                         
            var daysBetween = 0;
            
    
            // El ancla de los días siempre es la fecha del último pago; si no hay
            // pagos, la fecha de inicio del préstamo. Misma regla que la pantalla
            // de cobro (centro_cobros/pagos_prestamo).
            previousAmortizacion = data.prestamo.fecha_pago_en_pago?data.prestamo.fecha_pago_en_pago: formatted;

            var pendiente = data.prestamo.pendiente_en_pago?data.prestamo.pendiente_en_pago:0;
    
            daysBetween = (differenceInDays(new Date(),parse(previousAmortizacion, 'dd-MM-yyyy', new Date())));  
            var interes_nuevo = toNumber(cuota.capital) * ((toNumber(data.prestamo.interes) / 100) / 30) * daysBetween;
            var interes_total = interes_nuevo + toNumber(pendiente) - toNumber(cuota.descuento) + toNumber(cuota.aumento_interes);



            const divisor = toNumber(cuota.capital) * ((toNumber(data.prestamo.interes) / 100) / 30);
            cuota.dias_acumulados = divisor > 0 ? (interes_total / divisor).toFixed(2) : "0.00";
            cuota.cuota = toNumber(interes_total).toFixed(2);
    
            cuota.valorPagado = toNumber(cuota.interesPagado) + toNumber(cuota.capitalPagado);
    
    
    
    /*        if(index == cuotas.length - 1) {
              if(cuota.fecha_pagado){
                var cuotaDiaria = (cuota["interes"]/30);
                var diasPasados = Math.ceil(cuota["interesPagado"]/cuotaDiaria);
                
                //previousAmortizacion = addDays(parse(previousAmortizacion, 'dd-MM-yyyy', new Date()), diasPasados);
             //   const day = String(previousAmortizacion.getUTCDate()).padStart(2, '0');
                const month = String(previousAmortizacion.getUTCMonth() + 1).padStart(2, '0');
                const year = previousAmortizacion.getUTCFullYear();
                previousAmortizacion = `${day}-${month}-${year}`;
                var difference = differenceInDays(parse(previousAmortizacion, 'dd-MM-yyyy', new Date()),new Date());
                alert(difference);
        
              }
              daysBetween = (differenceInDays(parse(previousAmortizacion, 'dd-MM-yyyy', new Date()),new Date()));  
              
    
              var isLater = daysBetween > 0  || daysBetween < -30;
              
              var valorCuota = !isLater ? ((cuota.valor/30)*Math.abs(daysBetween)).toFixed(2) : cuota.valor
              
              cuota.cuotaoriginal = cuota.valor;
              cuota.valor = valorCuota;
        
            }
            else{
    
              if(cuota.fecha_pagado){
                var proximaCuota = cuotas[index+1];
    
    
                var cuotaDiaria = (cuota["interes"]/30);
                var diasPasados = Math.ceil(cuota["interesPagado"]/cuotaDiaria);
                
                var actualDate = addDays(parse(cuota.Fecha, 'dd-MM-yyyy', new Date()), diasPasados);
                actualDate = actualDate.getDate() + "-" + ((actualDate.getMonth()+1) ) + "-" + actualDate.getFullYear();
                var daysBetween = differenceInDays(parse(actualDate, 'dd-MM-yyyy', new Date()),parse(proximaCuota.Fecha, 'dd-MM-yyyy', new Date()));
    
                var valorCuota = ((cuota.valor/30)*Math.abs(daysBetween)).toFixed(2) 
    
                cuota.cuotaoriginal = cuota.valor;
                cuota.valor = valorCuota;
              }
      
            }
    */        
            
          });
        

        setAmortizacion(cuotas);
      }
      else{
        // Backend can send fecha_inicio as dd-MM-yyyy or ISO.
        // Parse both formats to avoid Invalid Date -> NaN calculations.
        
        var prevFecha = data["amortizaciones"][data["amortizaciones"].length-1].fecha;
        var fechaBase = parse(prevFecha, 'dd-MM-yyyy', new Date());
        var ahora = new Date();
        var frecuencia = data.prestamo.frecuencia;

        data["amortizaciones"].map(cuota => {
          cuota.cuota = cuota.cuota
          cuota.interes = cuota.cuota
          interes2 += cuota.cuota;
       });

        var cantidad = 0;
        if (frecuencia === 'Diario')         cantidad = differenceInDays(ahora, fechaBase);
        else if (frecuencia === 'Semanal')   cantidad = differenceInWeeks(ahora, fechaBase);
        else if (frecuencia === 'Quincenal') cantidad = Math.floor(differenceInDays(ahora, fechaBase) / 15);
        else if (frecuencia === 'Mensual')   cantidad = differenceInMonths(ahora, fechaBase);

        for (var i = 0; i < cantidad; i++) {
          var fecha;
          if (frecuencia === 'Diario')         fecha = addDays(fechaBase, i + 1);
          else if (frecuencia === 'Semanal')   fecha = addDays(fechaBase, (i + 1) * 7);
          else if (frecuencia === 'Quincenal') fecha = addDays(fechaBase, (i + 1) * 15);
          else if (frecuencia === 'Mensual')   fecha = addMonths(fechaBase, i + 1);
          else continue;

          var ultimaCuota = data["amortizaciones"][data["amortizaciones"].length - 1];
          data["amortizaciones"].push({
            numero_cuota: data["amortizaciones"].length + 1,
            fecha: format(fecha, 'dd-MM-yyyy'),
            capital: ultimaCuota.capital,
            cuota: ultimaCuota.cuota,
            estado: "pendiente",
            valorPagado: "0.00"
          });
        }

        setAmortizacion(data["amortizaciones"]);
      }

      data["prestamo"]["interesPendiente"] = interes2;
      
    }
    else{
      setAmortizacion(data["amortizaciones"]);
    }
    setPrestamo(data["prestamo"]);

    // Inicial cobrado: viene de `iniciales` vía LEFT JOIN del backend
    // (solicitudes_prestamos.inicial_id → iniciales.monto). Si el préstamo no
    // tiene inicial enlazado, monto_inicial es 0.
    const inicial = parseFloat(data["prestamo"]?.monto_inicial) || 0;
    setMontoInicial(inicial);
    setMontoInicialText(formatNumberWithCommas(inicial.toFixed(2)));

    setAtraso(data["atraso"]);
    setRecuperaciones(data["recuperaciones"].length > 0 ? data["recuperaciones"][0]["status"]=='completada' ? "incautado" : "" : "");

    return {recuperaciones: data["recuperaciones"].length > 0 ? data["recuperaciones"][0]["status"]=='completada' ? "incautado" : "" : "",productoid:data["prestamo"]["producto"]}
    

 }


  const fetchSolicitud = async (productosFinancieros) => {
    var url = `${process.env.REACT_APP_SERVER_URL}/api/solicitudes-prestamo/detalle/${id}`;
    var response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
      }
    });
    if (!response.ok) {
      const error = await response.json();
      console.log(error)
      return;
    }
    var solicitud = await response.json();

    var productoFin = Array.isArray(productosFinancieros)
      ? productosFinancieros.find((p) => p.idprodfinanciero === solicitud.id_productofinanciero)
      : null;
    var interesParsed = null;
    if (productoFin?.interes) {
      try {
        interesParsed =
          typeof productoFin.interes === 'string' ? JSON.parse(productoFin.interes) : productoFin.interes;
      } catch (_e) {
        interesParsed = {};
      }
    }

    var recuperaciones = await fetchPrestamo(solicitud.prestamo_id, interesParsed);
    setFormValues(JSON.parse(solicitud.campos));
    onProductoFinancieroChange(solicitud.id_productofinanciero,productosFinancieros,solicitud,recuperaciones["recuperaciones"],recuperaciones["productoid"]);
  }



  const onProductoFinancieroChange = async(e,productosFinancieros,solicitud,recuperaciones,productoid) => {
    var producto = Array.isArray(productosFinancieros) ? productosFinancieros.find(producto => producto.idprodfinanciero === e) : null;

    if (!producto) {
      console.log("Error: Producto financiero no encontrado");
      return;
    }

    setFinancialProductSelected(producto.idprodfinanciero);
    setGeneral(JSON.parse(producto.generales));
    setFormulario(JSON.parse(producto.formulario));
    setCamposInventario(JSON.parse(producto.fields));
    setMora(JSON.parse(producto.mora));
    setInteres(JSON.parse(producto.interes));

//    setFormValues({13: JSON.parse(producto.interes).tasa,14:JSON.parse(producto.mora).valorMora})



    let url = `${process.env.REACT_APP_SERVER_URL}/api/productos/${localStorage.getItem('idcompany')}/${producto.id}?estado=${recuperaciones == "" ? "vendido" : "incautado"}&estadoInicial=pendiente`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
            'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        }
      });
  
      if (!response.ok) {
        const error = await response.json();
        console.log(error)
        return;
      }

      var data = await response.json();
      
      // Verificar que data sea un array
      const productosArray = Array.isArray(data) ? data : [];
      setProductos(productosArray);
      // Buscar el producto solo si data es un array
      if (Array.isArray(data.productos)) {
        setProductoSelected(data.productos.find(producto => producto.id == productoid));
        
      } else {
        alert("Error: La respuesta de la API no es un array:", data);
        setProductoSelected(null);
      }
  
    } catch (error) {
      console.log(error)
      throw error;
    }
  }



  // Handler functions for AssignLoanToPortfolioDialog
  const handleOpenAssignPortfolioDialog = () => {
    setOpenAssignPortfolioDialog(true);
  };

  const handleCloseAssignPortfolioDialog = () => {
    setOpenAssignPortfolioDialog(false);
  };

  const handleOpenEliminarPrestamoPortafolioDialog = () => {
    setOpenEliminarPrestamoPortafolioDialog(true);
  };

  const handleCloseEliminarPrestamoPortafolioDialog = () => {
    setOpenEliminarPrestamoPortafolioDialog(false);
  };

  const handleIrrecuperable = () => {
    setMessageIrrecuperable(prestamo.estado == "irrecuperable" ? "¿Está seguro que desea desmarcar el préstamo como irrecuperable?" : "¿Está seguro que desea marcar el préstamo como irrecuperable?");
    setOpenIrrecuperableDialog(true);
  };

  const handleCloseIrrecuperableDialog = () => {
    setOpenIrrecuperableDialog(false);
  };

  const handleConfirmIrrecuperable = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/prestamos/${prestamo.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify({
          estado: prestamo.estado == "irrecuperable" ? "activo" : "irrecuperable",
        })
      });

      if (!response.ok) {
        throw new Error('Error al marcar el préstamo como irrecuperable');
      }

      // Show success message
      setMessageAlert(prestamo.estado == "irrecuperable" ? "El préstamo se ha desmarcado como irrecuperable con exito." : "El préstamo se ha marcado como irrecuperable con exito.");
      setOpenAlert(true);
      setOpenIrrecuperableDialog(false);
      
      // Refresh loan data
      if (productosFinancieros.length > 0) {
        fetchSolicitud(productosFinancieros);
      }
      
    } catch (error) {
      console.error('Error marking loan as irrecuperable:', error);
      // You could add error handling here
    }
  };

  const PROTECTED_FIELD_IDS = new Set([10, 11, 12, 13]);

  const handleStartEdit = () => {
    setEditValues({ ...formValues });
    setEditErrors({});
    setIsEditing(true);
  };

  const handleCancelEdit = () => {
    setEditValues({});
    setEditErrors({});
    setIsEditing(false);
  };

  const handleEditInputChange = (id, value) => {
    setEditValues((prev) => ({ ...prev, [id]: value }));
    setEditErrors((prev) => ({ ...prev, [id]: undefined }));
  };

  const handleSaveEdit = async () => {
    if (!formulario?.campos) return;

    const newErrors = {};
    formulario.campos.forEach((campo) => {
      if (PROTECTED_FIELD_IDS.has(campo.id)) return;
      if (campo.required) {
        const val = editValues[campo.id];
        if (val === undefined || val === null || val === '') {
          newErrors[campo.id] = `${campo.name} es requerido`;
        }
      }
    });
    if (Object.keys(newErrors).length > 0) {
      setEditErrors(newErrors);
      return;
    }

    const camposToSave = {};
    const clienteCamposToSave = {};
    formulario.campos.forEach((campo) => {
      if (PROTECTED_FIELD_IDS.has(campo.id)) return;
      const value = editValues[campo.id] ?? null;
      camposToSave[campo.id] = value;
      if (campo.category === 'Datos personales') {
        clienteCamposToSave[campo.id] = value;
      }
    });

    const body = { campos: camposToSave };
    if (Object.keys(clienteCamposToSave).length > 0) {
      body.cliente_campos = clienteCamposToSave;
    }

    setSavingEdit(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/prestamos/${prestamo.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany'),
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        setMessageAlert('Error al actualizar los datos del préstamo.');
        setOpenAlert(true);
        return;
      }

      setMessageAlert('Datos del préstamo actualizados exitosamente.');
      setOpenAlert(true);
      setIsEditing(false);
      setEditValues({});
      setEditErrors({});

      if (productosFinancieros.length > 0) {
        fetchSolicitud(productosFinancieros);
      }
    } catch (error) {
      console.error('Error updating loan data:', error);
      setMessageAlert('Ocurrió un error al actualizar los datos del préstamo.');
      setOpenAlert(true);
    } finally {
      setSavingEdit(false);
    }
  };

  const cancelarPrestamo = async () => {
    setOpenCancelConfirmDialog(false);
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/prestamos/${prestamo.id}/cancelar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify({incautado: recuperaciones == "incautado" ? true : false,producto_id: productoSelected?.id})
      });

      if (!response.ok) {
        throw new Error('Error al cancelar el préstamo');
      }
      var data = await response.json();
      setMessageAlert("El préstamo se ha cancelado exitosamente.");
      setOpenAlert(true);

      // Refresh loan data
      if (productosFinancieros.length > 0) {
        fetchSolicitud(productosFinancieros);
      }
    } catch (error) {
      console.error('Error al cancelar el préstamo:', error);
      setMessageAlert("Ocurrió un error al cancelar el préstamo.");
      setOpenAlert(true);
      setOpenCancelConfirmDialog(false); // Close the confirmation dialog even on error
    }
  };

  const handleRecalcularPlazo = async (nuevoPlazo) => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/prestamos/${prestamo.id}/plazo`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
        'X-company-ID': localStorage.getItem('idcompany')
      },
      body: JSON.stringify({ plazo: nuevoPlazo })
    });

    if (!response.ok) {
      let detail = '';
      try {
        const err = await response.json();
        detail = err?.error || err?.message || JSON.stringify(err);
      } catch (_e) {
        try {
          detail = await response.text();
        } catch (_e2) {
          detail = '';
        }
      }
      throw new Error(detail || 'Error al recalcular el plazo del préstamo.');
    }

    if (productosFinancieros.length > 0) {
      fetchSolicitud(productosFinancieros);
    }
  };

  const handleSaveAmortization = async (updatedAmortizacion) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/prestamos/${prestamo.id}/amortizacion`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify({
          amortizacion: updatedAmortizacion,
          metodo: prestamo.metodo
        })
      });

      if (!response.ok) {
        let detail = '';
        try {
          const err = await response.json();
          detail = err?.error || err?.message || JSON.stringify(err);
        } catch (e) {
          try {
            detail = await response.text();
          } catch (e2) {
            detail = '';
          }
        }
        throw new Error(detail ? `Error al actualizar la amortización: ${detail}` : 'Error al actualizar la amortización');
      }

      // Update local state
      setAmortizacion(updatedAmortizacion);
      
      // Refresh loan data
      if (productosFinancieros.length > 0) {
        fetchSolicitud(productosFinancieros);
      }
    } catch (error) {
      console.error('Error updating amortization:', error);
      throw error;
    }
  };

  const toNumber = (value) => {
    if (value === null || value === undefined || value === "") return 0;
    const normalized = typeof value === "string" ? value.replaceAll(",", "") : value;
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const hayAtraso = parseFloat(atraso) > 0;

  return (
    <Box>
      <AlertMessageDialog message={messageAlert} title={''} severity="success" color="success" open={openAlert} handleClose={() => setOpenAlert(false)} />

      <AppTheme themeComponents={{}}>
        <CssBaseline enableColorScheme />
        <Box sx={{ display: 'flex' }}>
          <SideMenu />
          <Box component="main" sx={{ flexGrow: 1, overflow: 'auto', bgcolor: 'background.default', minHeight: '100vh' }}>
            <Stack sx={{ alignItems: 'stretch', pb: 6, mt: { xs: 8, md: 0 } }}>
              <Header parent="Gestion Comercial" child="Prestamos" />

              <Box sx={{ px: { xs: 2, md: 4 }, pt: 3 }}>

                {/* ── Page header ── */}
                <Box display="flex" alignItems="flex-start" justifyContent="space-between" flexWrap="wrap" gap={2} mb={3}>
                  <Box display="flex" alignItems="center" gap={2}>
                    <Button
                      variant="text" size="small" startIcon={<ArrowBack />}
                      onClick={() => navigate(-1)}
                      sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'none', px: 0.5, minWidth: 0 }}
                    >
                      Préstamos
                    </Button>
                    <Divider orientation="vertical" flexItem />
                    <Box>
                      <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
                        <Typography variant="h5" fontWeight={800} letterSpacing="-0.5px">
                          Préstamo {prestamo.loan_id ? `#${prestamo.loan_id}` : ''}
                        </Typography>
                        {prestamo.estado && <EstadoChip estado={prestamo.estado} />}
                      </Box>
                      <Typography variant="body2" color="text.secondary" mt={0.25} align='left'>
                        Detalles del préstamo aprobado
                      </Typography>
                    </Box>
                  </Box>

                  <Box display="flex" gap={1} alignItems="center" flexWrap="wrap">
                    {!isEditing && (
                      <Button
                        variant="outlined" size="small" startIcon={<Description />}
                        onClick={() => setOpenContractDialog(true)}
                        sx={{ fontWeight: 600, textTransform: 'none' }}
                      >
                        Generar Contrato
                      </Button>
                    )}
                    {isEditing && (
                      <>
                        <Button
                          variant="outlined" size="small" startIcon={<Close />}
                          onClick={handleCancelEdit}
                          disabled={savingEdit}
                          sx={{ fontWeight: 600, textTransform: 'none' }}
                        >
                          Cancelar
                        </Button>
                        <Button
                          variant="contained" color="primary" size="small" startIcon={<Check />}
                          onClick={handleSaveEdit}
                          disabled={savingEdit}
                          sx={{ fontWeight: 600, textTransform: 'none' }}
                        >
                          {savingEdit ? 'Guardando…' : 'Guardar Cambios'}
                        </Button>
                      </>
                    )}
                    {prestamo.estado === 'activo' && !isEditing && (
                      <Can modulo="prestamos" accion="cancelar">
                        <Button
                          variant="contained" color="error" size="small" startIcon={<RemoveCircle />}
                          onClick={() => setOpenCancelConfirmDialog(true)}
                          sx={{ fontWeight: 600, textTransform: 'none' }}
                        >
                          Cancelar Préstamo
                        </Button>
                      </Can>
                    )}
                    {!isEditing && (
                      <IconButton
                        size="small"
                        onClick={(e) => setMenuEl(e.currentTarget)}
                        sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1.5, p: 0.75 }}
                      >
                        <MoreVert fontSize="small" />
                      </IconButton>
                    )}
                    <Menu
                      anchorEl={menuEl} open={Boolean(menuEl)} onClose={() => setMenuEl(null)}
                      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                      slotProps={{ paper: { sx: { borderRadius: 2, minWidth: 220, boxShadow: '0 4px 20px rgba(0,0,0,0.12)' } } }}
                    >
                      {prestamo.estado === 'activo' && (
                        <Can modulo="prestamos" accion="editar">
                          <MenuItem onClick={() => { setMenuEl(null); handleStartEdit(); }}>
                            <Edit sx={{ mr: 1.5, fontSize: 18, color: 'primary.main' }} />
                            <Typography variant="body2" fontWeight={600}>
                              Editar Datos
                            </Typography>
                          </MenuItem>
                        </Can>
                      )}
                      <Can modulo="portafolio" accion="editar">
                        <MenuItem onClick={() => { setMenuEl(null); prestamo.portafolio_id ? handleOpenEliminarPrestamoPortafolioDialog() : handleOpenAssignPortfolioDialog(); }}>
                          <WalletOutlined sx={{ mr: 1.5, fontSize: 18, color: 'primary.main' }} />
                          <Box>
                            <Typography variant="body2" fontWeight={600}>
                              {prestamo.portafolio_id ? 'Gestionar Portafolio' : 'Asignar Portafolio'}
                            </Typography>
                            {prestamo.portafolio_id && (
                              <Typography variant="caption" color="text.secondary">{prestamo.portafolio_nombre}</Typography>
                            )}
                          </Box>
                        </MenuItem>
                      </Can>
                      <Can modulo="prestamos" accion="editar">
                        <MenuItem onClick={() => { setMenuEl(null); handleIrrecuperable(); }}>
                          <FmdBadOutlined sx={{ mr: 1.5, fontSize: 18, color: prestamo.estado === 'irrecuperable' ? 'primary.main' : 'error.main' }} />
                          <Typography
                            variant="body2" fontWeight={600}
                            color={prestamo.estado === 'irrecuperable' ? 'text.primary' : 'error.main'}
                          >
                            {prestamo.estado === 'irrecuperable' ? 'Desmarcar Irrecuperable' : 'Marcar como Irrecuperable'}
                          </Typography>
                        </MenuItem>
                      </Can>
                    </Menu>
                  </Box>
                </Box>

                {/* ── Metric summary cards ── */}
                {prestamo.estado == 'activo' && (
                <Grid container spacing={2} sx={{ mb: 3 }}>
                  {[
                    {
                      label: 'Total Pagado',
                      value: `${moneda?.label}$${formatNumberWithCommas(prestamo.totalPagado)}`,
                      accent: '#2e7d32',
                      valueColor: '#1b5e20',
                    },
                    {
                      label: 'Pendiente',
                      value: `${moneda?.label}$${prestamo.metodo == 'plazo_indefinido' ?
                        formatNumberWithCommas(prestamo.capitalPendiente?toNumber(prestamo.capitalPendiente)+amortizacion.reduce((total, cuota) => total + toNumber(cuota.cuota), 0):prestamo.monto_solicitado):
                        formatNumberWithCommas((parseFloat(prestamo.capitalPendiente)+parseFloat(prestamo.interesPendiente)+parseFloat(prestamo.moraPendiente)).toFixed(2))}`,
                      accent: '#18586b',
                      valueColor: '#18586b',
                    },
                    {
                      label: 'Atraso',
                      value: `${moneda?.label}$${atraso ? formatNumberWithCommas(atraso) : '0.00'}`,
                      accent: hayAtraso ? '#c62828' : '#9e9e9e',
                      valueColor: hayAtraso ? 'error.main' : 'text.disabled',
                    },
                    {
                      label: 'Portafolio',
                      chip: prestamo.portafolio_id ? prestamo.portafolio_nombre : null,
                      accent: '#9e9e9e',
                      valueColor: 'text.secondary',
                    },
                  ].map((metric) => (
                    <Grid item size={{ xs: 12, sm: 6, md: 3 }} key={metric.label}>
                      <Card
                        variant="outlined"
                        sx={{
                          borderRadius: 2,
                          border: '1px solid',
                          borderColor: 'divider',
                          bgcolor: 'background.paper',
                          height: '100%',
                          position: 'relative',
                          overflow: 'hidden',
                          transition: 'border-color 0.15s ease',
                          '&:hover': { borderColor: metric.accent },
                          '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: 3,
                            height: '100%',
                            bgcolor: metric.accent,
                          },
                        }}
                      >
                        <CardContent sx={{ py: 2, px: 2.5, pl: 3, '&:last-child': { pb: 2 } }}>
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: 'block', fontSize: '0.68rem', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', mb: 0.75 }}
                          >
                            {metric.label}
                          </Typography>
                          {metric.chip !== undefined ? (
                            metric.chip
                              ? <Chip label={metric.chip} size="small" sx={{ fontWeight: 600, bgcolor: 'primary.main', color: 'primary.contrastText', height: 24 }} />
                              : <Typography variant="body2" color="text.disabled" sx={{ fontWeight: 500, fontStyle: 'italic', fontSize: '0.9rem' }}>Sin asignar</Typography>
                          ) : (
                            <Typography
                              fontWeight={700}
                              color={metric.valueColor}
                              sx={{ fontSize: { xs: '1.1rem', sm: '1.25rem' }, letterSpacing: '-0.01em', lineHeight: 1.2 }}
                            >
                              {metric.value}
                            </Typography>
                          )}
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
                )}
                {prestamo.estado !== 'activo' && (
                <Grid container spacing={2} sx={{ mb: 3 }}>
                  {[
                    {
                      label: 'Total Pagado',
                      value: `${moneda?.label}$${formatNumberWithCommas(prestamo.totalPagado)}`,
                      accent: '#2e7d32',
                      valueColor: '#1b5e20',
                    },
                    {
                      label: 'Pendiente',
                      value: `${moneda?.label}$${0.00}`,
                      accent: '#18586b',
                      valueColor: '#18586b',
                    },
                    {
                      label: 'Atraso',
                      value: `${moneda?.label}$${0.00}`,
                      accent: hayAtraso ? '#c62828' : '#9e9e9e',
                      valueColor: hayAtraso ? 'error.main' : 'text.disabled',
                    },
                    {
                      label: 'Portafolio',
                      chip: prestamo.portafolio_id ? prestamo.portafolio_nombre : null,
                      accent: '#9e9e9e',
                      valueColor: 'text.secondary',
                    },
                  ].map((metric) => (
                    <Grid item size={{ xs: 12, sm: 6, md: 3 }} key={metric.label}>
                      <Card
                        variant="outlined"
                        sx={{
                          borderRadius: 2,
                          border: '1px solid',
                          borderColor: 'divider',
                          bgcolor: 'background.paper',
                          height: '100%',
                          position: 'relative',
                          overflow: 'hidden',
                          transition: 'border-color 0.15s ease',
                          '&:hover': { borderColor: metric.accent },
                          '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: 3,
                            height: '100%',
                            bgcolor: metric.accent,
                          },
                        }}
                      >
                        <CardContent sx={{ py: 2, px: 2.5, pl: 3, '&:last-child': { pb: 2 } }}>
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: 'block', fontSize: '0.68rem', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', mb: 0.75 }}
                          >
                            {metric.label}
                          </Typography>
                          {metric.chip !== undefined ? (
                            metric.chip
                              ? <Chip label={metric.chip} size="small" sx={{ fontWeight: 600, bgcolor: 'primary.main', color: 'primary.contrastText', height: 24 }} />
                              : <Typography variant="body2" color="text.disabled" sx={{ fontWeight: 500, fontStyle: 'italic', fontSize: '0.9rem' }}>Sin asignar</Typography>
                          ) : (
                            <Typography
                              fontWeight={700}
                              color={metric.valueColor}
                              sx={{ fontSize: { xs: '1.1rem', sm: '1.25rem' }, letterSpacing: '-0.01em', lineHeight: 1.2 }}
                            >
                              {metric.value}
                            </Typography>
                          )}
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
                )}

                {/* ── Stacked content: form on top, tabs/amortization full-width below ── */}
                {financialProductSelected && (
                  <>
                    {/* Form cards — distributed in columns to stay compact */}
                    <Grid container spacing={2} alignItems="flex-start" sx={{ mb: 3 }}>
                      {formulario.categorias.map((categoria) => {
                        const camposCategoria = formulario.campos.filter(c => c.category === categoria.name);
                        return (
                          <React.Fragment key={categoria.id}>
                            {categoria.id === 3 && general.requiereInventario && (
                              <Grid item size={{ xs: 12, md: 6, lg: 4 }}>
                              <Card variant="outlined" sx={{ borderRadius: 2, boxShadow: 'none', border: '1px solid', borderColor: 'divider', height: '100%', bgcolor: 'background.paper' }}>
                                <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
                                  <SectionHeader
                                    title={safeCapitalize(`${camposInventario?.[0]?.alias ?? ''} financiado`)}
                                    action={recuperaciones === 'incautado' ? <Chip label="Incautado" color="error" size="small" sx={{ height: 22, fontSize: '0.7rem', fontWeight: 600 }} /> : null}
                                  />
                                  {errors['producto'] && (
                                    <Typography fontSize={12} color="error" sx={{ mb: 1.5 }}>{errors['producto']}</Typography>
                                  )}
                                  <Grid container rowSpacing={2.25} columnSpacing={2}>
                                    {productoSelected && camposInventario.map((campo, index) => {
                                      const rawValue = JSON.parse(productoSelected.campos)[campo.id];
                                      const displayValue = campo.type === 'monto'
                                        ? `${moneda?.label}$${formatNumberWithCommas((rawValue ?? 0).toString())}`
                                        : campo.type === 'numero'
                                          ? formatNumberWithCommas((rawValue ?? 0).toString())
                                          : rawValue;
                                      return (
                                        <React.Fragment key={campo.id}>
                                          <Grid item size={6}>
                                            <DetailField
                                              label={campo.id === 'id' ? safeCapitalize(campo.alias) : safeCapitalize(campo.name)}
                                              value={displayValue}
                                            />
                                          </Grid>
                                          {index === camposInventario.length - 1 && (
                                            <Grid item size={6}>
                                              <DetailField
                                                label="Inicial"
                                                value={`${moneda?.label}$${montoInicialText}`}
                                              />
                                            </Grid>
                                          )}
                                        </React.Fragment>
                                      );
                                    })}
                                  </Grid>
                                </CardContent>
                              </Card>
                              </Grid>
                            )}

                            <Grid item size={{ xs: 12, md: 6, lg: 4 }}>
                            <Card variant="outlined" sx={{ borderRadius: 2, boxShadow: 'none', border: '1px solid', borderColor: 'divider', height: '100%', bgcolor: 'background.paper' }}>
                              <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
                                <SectionHeader title={categoria.name} />
                                <Grid container rowSpacing={2.25} columnSpacing={2}>
                                  {camposCategoria.map((campo) => {
                                    const isMoraInline = campo.id === 14;
                                    const isProtected = PROTECTED_FIELD_IDS.has(campo.id);
                                    const editableInBulk = isEditing && !isProtected;
                                    let helper = '';
                                    if (campo.id === 10) helper = `Rango ${moneda?.label}$${formatNumberWithCommas(general.montoMinimo.toFixed(2))} – ${moneda?.label}$${formatNumberWithCommas(general.montoMaximo.toFixed(2))}`;
                                    if (campo.id === 13) helper = `${safeCapitalize(interes.tipoInteres)} · ${interes.tasa}% mensual`;
                                    if (campo.id === 14) helper = `${safeCapitalize(mora.tipoMora)} · ${mora.valorMora}${mora.esPorcentaje ? '%' : ''}`;

                                    const rawValue = formValues[campo.id];
                                    let displayValue = rawValue;
                                    if (campo.type === 'ID') displayValue = formatIdentification(rawValue || '');
                                    else if (campo.type === 'numerotel') displayValue = formatPhone(rawValue) || '';
                                    else if (campo.type === 'monto') displayValue = rawValue != null && rawValue !== '' ? `${moneda?.label}$${formatNumberWithCommas(rawValue.toString())}` : '';
                                    else if (campo.type === 'numero') displayValue = rawValue != null && rawValue !== '' ? formatNumberWithCommas(rawValue.toString()) : '';

                                    if (editableInBulk) {
                                      const editRaw = editValues[campo.id];
                                      const errorMsg = editErrors[campo.id];
                                      const commonProps = {
                                        size: 'small',
                                        fullWidth: true,
                                        error: !!errorMsg,
                                        helperText: errorMsg || helper || undefined,
                                      };

                                      let inputEl;
                                      if (campo.type === 'ID') {
                                        inputEl = (
                                          <TextField
                                            {...commonProps}
                                            value={formatIdentification(editRaw || '')}
                                            onChange={(e) => handleEditInputChange(campo.id, e.target.value)}
                                          />
                                        );
                                      } else if (campo.type === 'numerotel') {
                                        inputEl = (
                                          <TextField
                                            {...commonProps}
                                            value={formatPhone(editRaw) || ''}
                                            onChange={(e) => handleEditInputChange(campo.id, e.target.value)}
                                          />
                                        );
                                      } else if (campo.type === 'fecha') {
                                        inputEl = (
                                          <TextField
                                            {...commonProps}
                                            type="date"
                                            value={editRaw || ''}
                                            onChange={(e) => handleEditInputChange(campo.id, e.target.value)}
                                            InputLabelProps={{ shrink: true }}
                                          />
                                        );
                                      } else if (campo.type === 'monto') {
                                        inputEl = (
                                          <TextField
                                            {...commonProps}
                                            slotProps={{
                                              input: {
                                                startAdornment: <InputAdornment position="start">{moneda?.label}$</InputAdornment>,
                                              },
                                            }}
                                            value={editRaw != null && editRaw !== '' ? formatNumberWithCommas(editRaw.toString()) : ''}
                                            onChange={(e) => {
                                              const v = e.target.value.replaceAll(',', '');
                                              const parsed = v === '' ? '' : Number(v);
                                              handleEditInputChange(campo.id, Number.isFinite(parsed) ? parsed : '');
                                            }}
                                          />
                                        );
                                      } else if (campo.type === 'numero') {
                                        inputEl = (
                                          <TextField
                                            {...commonProps}
                                            type="number"
                                            value={editRaw ?? ''}
                                            onChange={(e) => handleEditInputChange(campo.id, e.target.value)}
                                          />
                                        );
                                      } else if (campo.type === 'opciones') {
                                        inputEl = (
                                          <FormControl fullWidth size="small" error={!!errorMsg}>
                                            <Selector
                                              value={editRaw || ''}
                                              onChange={(e) => handleEditInputChange(campo.id, e.target.value)}
                                              options={(campo.options || []).map((option) => ({ label: option, value: option }))}
                                              placeholder={campo.name}
                                            />
                                          </FormControl>
                                        );
                                      } else {
                                        inputEl = (
                                          <TextField
                                            {...commonProps}
                                            value={editRaw || ''}
                                            onChange={(e) => handleEditInputChange(campo.id, e.target.value)}
                                          />
                                        );
                                      }

                                      return (
                                        <Grid item size={{ xs: 12, sm: 6 }} key={campo.id}>
                                          <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{ display: 'flex', alignItems: 'center', gap: 0.5, fontSize: '0.68rem', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', mb: 0.75 }}
                                          >
                                            {campo.name}
                                            <Edit sx={{ fontSize: 11, color: 'primary.main' }} />
                                          </Typography>
                                          {inputEl}
                                        </Grid>
                                      );
                                    }

                                    if (isMoraInline && !isEditing) {
                                      return (
                                        <Grid item size={{ xs: 12, sm: 6 }} key={campo.id}>
                                          <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{ display: 'flex', alignItems: 'center', gap: 0.5, fontSize: '0.68rem', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', mb: 0.75 }}
                                          >
                                            {campo.name}
                                            <Edit sx={{ fontSize: 11, color: 'primary.main' }} />
                                          </Typography>
                                          <TextField
                                            size="small"
                                            fullWidth
                                            type="number"
                                            error={!!errors[campo.id]}
                                            value={rawValue || ''}
                                            onChange={(e) => handleInputChange(campo.id, e.target.value)}
                                            sx={{ '& .MuiInputBase-input': { fontWeight: 600, fontSize: '0.9rem' } }}
                                          />
                                        </Grid>
                                      );
                                    }

                                    return (
                                      <Grid item size={{ xs: 12, sm: 6 }} key={campo.id}>
                                        <DetailField
                                          label={campo.name}
                                          value={displayValue}
                                          emphasize={campo.id === 10 || campo.id === 13}
                                        />
                                        
                                        {errors[campo.id] && (
                                          <Typography variant="caption" color="error" sx={{ fontSize: '0.7rem', mt: 0.5, display: 'block' }}>
                                            {errors[campo.id]}
                                          </Typography>
                                        )}
                                      </Grid>
                                    );
                                  })}
                                </Grid>
                              </CardContent>
                            </Card>
                            </Grid>
                          </React.Fragment>
                        );
                      })}
                    </Grid>

                    {/* Tabs panel — full width */}
                    <Box>
                      <Card variant="outlined" sx={{ borderRadius: 2, boxShadow: 'none', border: '1px solid', borderColor: 'divider' }}>
                        <Box
                          sx={{
                            borderBottom: '1px solid',
                            borderColor: 'divider',
                            bgcolor: 'background.paper',
                            px: 1.5,
                          }}
                        >
                          <Tabs
                            value={tabValue}
                            onChange={handleTabChange}
                            variant="scrollable"
                            scrollButtons="auto"
                            allowScrollButtonsMobile
                            slotProps={{
                              indicator: {
                                sx: {
                                  height: 3,
                                  borderRadius: '3px 3px 0 0',
                                  bgcolor: 'primary.main',
                                },
                              },
                            }}
                            sx={{
                              minHeight: 48,
                              '& .MuiTab-root': {
                                textTransform: 'none',
                                fontWeight: 600,
                                fontSize: '0.82rem',
                                letterSpacing: '0.01em',
                                minHeight: 48,
                                px: 2,
                                py: 1.25,
                                color: 'text.secondary',
                                transition: 'color 0.15s ease, background-color 0.15s ease',
                                '&:hover': {
                                  color: 'text.primary',
                                  bgcolor: 'action.hover',
                                },
                                '&.Mui-selected': {
                                  color: 'primary.main',
                                  fontWeight: 700,
                                },
                                '& .MuiTab-iconWrapper': {
                                  fontSize: 18,
                                  mr: 1,
                                  mb: '0 !important',
                                },
                              },
                            }}
                          >
                            <Tab
                              icon={<ListAltOutlined />}
                              iconPosition="start"
                              label={prestamo.metodo === 'plazo_indefinido' ? 'Cuotas' : 'Amortización'}
                              value={prestamo.metodo === 'plazo_indefinido' ? 'Cuotas' : 'Amortizacion'}
                            />
                            <Tab icon={<HistoryOutlined />} iconPosition="start" label="Actividad y Notas" value="Actividad y Notas" />
                            <Tab icon={<ReceiptLongOutlined />} iconPosition="start" label="Pagos" value="Pagos" />
                            <Tab icon={<HandshakeOutlined />} iconPosition="start" label="Promesas" value="Promesas" />
                            <Tab icon={<RequestQuoteOutlined />} iconPosition="start" label="Cargos" value="Cargos" />
                            <Tab icon={<VerifiedUserOutlined />} iconPosition="start" label="Garantías" value="Garantias" />
                          </Tabs>
                        </Box>

                        <CardContent>
                          {/* Tab-level actions */}
                          {tabValue === 'Amortizacion' && prestamo.metodo !== 'plazo_indefinido' && (
                            <Box display="flex" justifyContent="flex-end" gap={1} mb={2}>
                              <Button variant="outlined" size="small" startIcon={<Print />} onClick={() => setOpenPrintAmortizationDialog(true)} sx={{ fontWeight: 600, textTransform: 'none' }}>Imprimir</Button>
                              <Can modulo="prestamos" accion="editar">
                                <Button variant="outlined" size="small" startIcon={<Edit />} onClick={() => setOpenEditAmortizationDialog(true)} sx={{ fontWeight: 600, textTransform: 'none' }}>Editar</Button>
                              </Can>
                            </Box>
                          )}
                          {tabValue === 'Cuotas' && prestamo.metodo === 'plazo_indefinido' && (
                            <Box display="flex" justifyContent="flex-end" mb={2}>
                              <Can modulo="prestamos" accion="editar">
                                <Button variant="outlined" size="small" startIcon={<Edit />} onClick={() => setOpenEditAmortizationDialog(true)} sx={{ fontWeight: 600, textTransform: 'none' }}>Editar</Button>
                              </Can>
                            </Box>
                          )}

                          {tabValue === 'Amortizacion' && (
                            <>
                              <Grid container spacing={2} sx={{ mb: 2.5 }}>
                                {[
                                  {
                                    label: 'Capital Pendiente',
                                    value: `${moneda?.label}$${formatNumberWithCommas(toNumber(prestamo.capitalPendiente).toFixed(2))}`,
                                    accent: '#18586b',
                                    valueColor: '#18586b',
                                  },
                                  {
                                    label: 'Interés Pendiente',
                                    value: `${moneda?.label}$${formatNumberWithCommas(toNumber(prestamo.interesPendiente).toFixed(2))}`,
                                    accent: '#b26a00',
                                    valueColor: '#b26a00',
                                  },
                                ].map((metric) => (
                                  <Grid item size={{ xs: 12, sm: 6 }} key={metric.label}>
                                    <Card
                                      variant="outlined"
                                      sx={{
                                        borderRadius: 2,
                                        border: '1px solid',
                                        borderColor: 'divider',
                                        bgcolor: 'background.paper',
                                        height: '100%',
                                        position: 'relative',
                                        overflow: 'hidden',
                                        transition: 'border-color 0.15s ease',
                                        '&:hover': { borderColor: metric.accent },
                                        '&::before': {
                                          content: '""',
                                          position: 'absolute',
                                          top: 0,
                                          left: 0,
                                          width: 3,
                                          height: '100%',
                                          bgcolor: metric.accent,
                                        },
                                      }}
                                    >
                                      <CardContent sx={{ py: 2, px: 2.5, pl: 3, '&:last-child': { pb: 2 } }}>
                                        <Typography
                                          variant="caption"
                                          color="text.secondary"
                                          sx={{ display: 'block', fontSize: '0.68rem', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', mb: 0.75 }}
                                        >
                                          {metric.label}
                                        </Typography>
                                        <Typography
                                          fontWeight={700}
                                          color={metric.valueColor}
                                          sx={{ fontSize: { xs: '1.1rem', sm: '1.25rem' }, letterSpacing: '-0.01em', lineHeight: 1.2 }}
                                        >
                                          {metric.value}
                                        </Typography>
                                      </CardContent>
                                    </Card>
                                  </Grid>
                                ))}
                              </Grid>

                              <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 'none' }}>
                                <Table size="small">
                                  <TableHead>
                                    <TableRow>
                                      <StyledCellHeader sx={{ width: 80 }}>N° Cuota</StyledCellHeader>
                                      <StyledCellHeader sx={{ textAlign: 'center' }}>Fecha</StyledCellHeader>
                                      <StyledCellHeader sx={{ textAlign: 'center' }}>Capital</StyledCellHeader>
                                      <StyledCellHeader sx={{ textAlign: 'center' }}>Interés</StyledCellHeader>
                                      <StyledCellHeader sx={{ textAlign: 'center' }}>Cuota</StyledCellHeader>
                                      <StyledCellHeader sx={{ textAlign: 'center' }}>Pagado</StyledCellHeader>
                                      <StyledCellHeader sx={{ textAlign: 'center' }}>Estado</StyledCellHeader>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {amortizacion.map((amort) => (
                                      <TableRow key={amort.numero_cuota} hover>
                                        <TableCell sx={{ textAlign: 'center' }}>{amort.numero_cuota}</TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>{amort.fecha}</TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>{amort.capital != null ? formatNumberWithCommas(parseFloat(amort.capital).toFixed(2)) : '-'}</TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>{amort.interes != null ? formatNumberWithCommas(parseFloat(amort.interes).toFixed(2)) : '-'}</TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>{amort.cuota}</TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>{amort.valorPagado}</TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}><EstadoChip estado={amort.estado} /></TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </>
                          )}

                          {tabValue === 'Cuotas' && interes.interesDiario && prestamo.estado == 'activo' && (
                            <>
                                                          <Grid container spacing={2} sx={{ mb: 2.5 }}>
                                {[
                                  {
                                    label: 'Capital Pendiente',
                                    value: `${moneda?.label}$${formatNumberWithCommas(toNumber(prestamo.capitalPendiente).toFixed(2))}`,
                                    accent: '#18586b',
                                    valueColor: '#18586b',
                                  },
                                  {
                                    label: 'Interés Pendiente',
                                    value: `${moneda?.label}$${formatNumberWithCommas(toNumber(amortizacion.reduce((acc, curr) => acc + toNumber(curr.cuota), 0)).toFixed(2))}`,
                                    accent: '#b26a00',
                                    valueColor: '#b26a00',
                                  },
                                ].map((metric) => (
                                  <Grid item size={{ xs: 12, sm: 6 }} key={metric.label}>
                                    <Card
                                      variant="outlined"
                                      sx={{
                                        borderRadius: 2,
                                        border: '1px solid',
                                        borderColor: 'divider',
                                        bgcolor: 'background.paper',
                                        height: '100%',
                                        position: 'relative',
                                        overflow: 'hidden',
                                        transition: 'border-color 0.15s ease',
                                        '&:hover': { borderColor: metric.accent },
                                        '&::before': {
                                          content: '""',
                                          position: 'absolute',
                                          top: 0,
                                          left: 0,
                                          width: 3,
                                          height: '100%',
                                          bgcolor: metric.accent,
                                        },
                                      }}
                                    >
                                      <CardContent sx={{ py: 2, px: 2.5, pl: 3, '&:last-child': { pb: 2 } }}>
                                        <Typography
                                          variant="caption"
                                          color="text.secondary"
                                          sx={{ display: 'block', fontSize: '0.68rem', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', mb: 0.75 }}
                                        >
                                          {metric.label}
                                        </Typography>
                                        <Typography
                                          fontWeight={700}
                                          color={metric.valueColor}
                                          sx={{ fontSize: { xs: '1.1rem', sm: '1.25rem' }, letterSpacing: '-0.01em', lineHeight: 1.2 }}
                                        >
                                          {metric.value}
                                        </Typography>
                                      </CardContent>
                                    </Card>
                                  </Grid>
                                ))}
                              </Grid>

                            <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 'none' }}>
                              <Table size="small">
                                <TableHead>
                                  <TableRow>
                                    <StyledCellHeader sx={{ textAlign: 'center' }}>Días acumulados</StyledCellHeader>
                                    <StyledCellHeader sx={{ textAlign: 'center' }}>Valor</StyledCellHeader>
                                    <StyledCellHeader sx={{ textAlign: 'center' }}>Pagado</StyledCellHeader>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {amortizacion.map((amort) => (
                                    <TableRow key={amort.id} hover>
                                      <TableCell sx={{ textAlign: 'center' }}>{amort.dias_acumulados}</TableCell>
                                      <TableCell sx={{ textAlign: 'center' }}>{amort.cuota}</TableCell>
                                      <TableCell sx={{ textAlign: 'center' }}>{amort.valorPagado}</TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                            </>
                          )}

                          {tabValue === 'Cuotas' && !interes.interesDiario && (
                              <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 'none' }}>
                                <Table size="small">
                                  <TableHead>
                                    <TableRow>
                                      <StyledCellHeader sx={{ width: 80 }}>N° Cuota</StyledCellHeader>
                                      <StyledCellHeader sx={{ textAlign: 'center' }}>Fecha</StyledCellHeader>
                                      <StyledCellHeader sx={{ textAlign: 'center' }}>Capital</StyledCellHeader>
                                      <StyledCellHeader sx={{ textAlign: 'center' }}>Interés</StyledCellHeader>
                                      <StyledCellHeader sx={{ textAlign: 'center' }}>Cuota</StyledCellHeader>
                                      <StyledCellHeader sx={{ textAlign: 'center' }}>Pagado</StyledCellHeader>
                                      <StyledCellHeader sx={{ textAlign: 'center' }}>Estado</StyledCellHeader>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {amortizacion.map((amort) => (
                                      <TableRow key={amort.numero_cuota} hover>
                                        <TableCell sx={{ textAlign: 'center' }}>{amort.numero_cuota}</TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>{amort.fecha}</TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>{amort.capital != null ? formatNumberWithCommas(parseFloat(amort.capital).toFixed(2)) : '-'}</TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>{amort.interes != null ? formatNumberWithCommas(parseFloat(amort.cuota).toFixed(2)) : '-'}</TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>{amort.cuota}</TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>{amort.valorPagado}</TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}><EstadoChip estado={amort.estado} /></TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>


                          )}


                          {tabValue === 'Actividad y Notas' && <TimeLineNotes loanId={prestamo.id} loanInfo={prestamo} />}
                          {tabValue === 'Pagos' && <HistorialPagosPrestamo prestamoId={prestamo.id} metodo={prestamo.metodo} prestamo={prestamo} />}
                          {tabValue === 'Promesas' && <PromesasTab prestamo={prestamo} />}
                          {tabValue === 'Cargos' && <CargosAsignadosTab prestamo={prestamo} />}
                          {tabValue === 'Garantias' && <GarantiasPrestamo idPrestamo={prestamo.id} />}
                        </CardContent>
                      </Card>
                    </Box>

                  </>
                )}
              </Box>
            </Stack>
          </Box>
        </Box>

        <AssignLoanToPortfolioDialog open={openAssignPortfolioDialog} loanIdOriginal={prestamo.id} loanId={prestamo.loan_id} onClose={handleCloseAssignPortfolioDialog} />
        <EliminarPrestamoPortafolioDialog open={openEliminarPrestamoPortafolioDialog} loanIdOriginal={prestamo.id} loanId={prestamo.loan_id} onClose={handleCloseEliminarPrestamoPortafolioDialog} portafolio_id={prestamo.portafolio_id} />
        <OnGeneralMessageDialog open={openIrrecuperableDialog} onClose={handleCloseIrrecuperableDialog} title={prestamo.estado === 'irrecuperable' ? 'Confirmar Desmarcar Irrecuperable' : 'Confirmar Marcar Irrecuperable'} message={messageIrrecuperable} buttonText="Confirmar" onRegister={handleConfirmIrrecuperable} buttonColor="primarybutton" />
        <OnGeneralMessageDialog open={openCancelConfirmDialog} onClose={() => setOpenCancelConfirmDialog(false)} title="¿Estás seguro de cancelar este préstamo?" message="Esta acción cancelará permanentemente el préstamo. ¿Deseas continuar?" buttonText="Sí, Cancelar Préstamo" onRegister={cancelarPrestamo} buttonColor="error" />
        <ContractGenerationDialog open={openContractDialog} onClose={() => setOpenContractDialog(false)} prestamoId={prestamo.id} idProductofinanciero={prestamo.producto || prestamo.id_productofinanciero} />
        <PrintAmortizationDialog open={openPrintAmortizationDialog} onClose={() => setOpenPrintAmortizationDialog(false)} amortizacion={amortizacion} prestamo={prestamo} moneda={moneda} />
        <EditAmortizationDialog open={openEditAmortizationDialog} onClose={() => setOpenEditAmortizationDialog(false)} amortizacion={amortizacion} prestamo={prestamo} moneda={moneda} onSave={handleSaveAmortization} onRecalcularPlazo={handleRecalcularPlazo} />
      </AppTheme>
    </Box>
  );
}
